import { StringValidator } from "./StringValidator";
import {
  ValidatorResponse,
  ValidatorResponseType
} from "~/workera/utils/typedForms/validators/common/ValidatorResponse";

export class RegexValidator extends StringValidator {
  re: RegExp;
  invalidText: string;
  validText: string;
  errorIfMatch: boolean;

  constructor(
    re: RegExp,
    invalidText: string = "Invalid format for the input string",
    validText: string = "Valid string.",
    errorIfMatch: boolean = true
  ) {
    super();
    this.re = re;
    this.invalidText = invalidText;
    this.errorIfMatch = errorIfMatch;
    this.validText = validText;
  }

  validate(s: string): ValidatorResponse {
    if (!this.re.test(s) === this.errorIfMatch) {
      return new ValidatorResponse(ValidatorResponseType.ERROR, [
        this.invalidText
      ]);
    }

    return new ValidatorResponse(ValidatorResponseType.SUCCESS, [
      this.validText
    ]);
  }
}
